module.exports = __webpack_public_path__ + "img/aguacate.13533960.png";